import { CalendarItemType } from '@akin-home/amplify';
import { CalendarItemUnion } from '../types';

export * from './formatCalendarItemToModel';
export * from './getCalendarItemRecurrenceText';

export const calendarItemColors: Record<CalendarItemType, string> = {
  Event: '#dbf1ff',
  Goal: '#d9defb',
  Meal: '#ffebe4',
  Alert: '#e2f1ee',
  Alarm: '#fff5d9',
};

export const getCalendarItemBackgroundColor = (
  item: CalendarItemUnion
): string => {
  if ('color' in item && item.color) return item.color;

  return calendarItemColors[item.type];
};
